export default {"src":"/_next/static/media/capy_sad.b5a8fd31.svg","height":109,"width":153};